<template>
  <div class="protal-register">
    <!-- 右边表单 -->
    <div class="register-content">
      <div class="content-middle">
        <!-- 新平台 -->
        <div class="big-title">
          {{ $t('protaRegister.title') }}
        </div>
        <!-- 注册表单 -->
        <el-form autocomplete="off"
                 class="register-form"
                 :model="dataForm"
                 :rules="dataRule"
                 ref="dataForm"
                 @keyup.enter.native="dataFormSubmitHandle()">
          <input class="hide-input"
                 type="password"
                 name="password1" />
          <el-form-item class="form-content"
                        prop="username">
            <label>{{ $t('protaRegister.nameLabel') }}</label>
            <input :placeholder="$t('protaRegister.namePlace')"
                   type="text"
                   v-model="dataForm.username" />
          </el-form-item>
          <el-form-item class="form-content"
                        prop="userNameCn">
            <label>{{ $t('protaRegister.nameCnLabel') }}</label>
            <input :placeholder="$t('protaRegister.nameCnPlace')"
                   type="text"
                   v-model="dataForm.userNameCn" />
          </el-form-item>
          <el-form-item class="form-content"
                        prop="email">
            <label>{{ $t('protaRegister.mailLabel') }}</label>
            <input :placeholder="$t('protaRegister.mailPlace')"
                   type="text"
                   v-model="dataForm.email" />
          </el-form-item>
          <el-form-item class="form-content"
                        prop="mobile">
            <label>{{ $t('protaRegister.phoneLabel') }}</label>
            <input :placeholder="$t('protaRegister.phonePlace')"
                   type="text"
                   v-model="dataForm.mobile" />
          </el-form-item>
          <el-form-item class="form-content"
                        prop="captcha">
            <label>{{ $t('protaRegister.captchaLabel') }}</label>
            <input :placeholder="$t('protaRegister.captchaPlace')"
                   v-model="dataForm.captcha"
                   type="text" />
            <div class="captcha">
              <div @click="getCaptcha()">{{$t('protaRegister.captchaBtn')}}</div>
            </div>
          </el-form-item>
          <el-form-item class="form-content"
                        prop="password">
            <label>{{ $t('protaRegister.passwordLabel') }}</label>
            <input :placeholder="$t('protaRegister.passwordPlace')"
                   type="password"
                   v-model="dataForm.password" />
          </el-form-item>
          <el-form-item class="form-content"
                        prop="passwordSure">
            <label>{{ $t('protaRegister.passwordSureLabel') }}</label>
            <input :placeholder="$t('protaRegister.passwordSurePlace')"
                   type="password"
                   v-model="dataForm.passwordSure" />
          </el-form-item>
          <div class="register-bar">
            <div>
              <input type="checkbox" />
              &nbsp;{{ $t('protaRegister.agree') }}《<span>{{ $t('protaRegister.agreement') }}</span>》
            </div>
          </div>
        </el-form>
        <!-- 登录注册按钮 -->
        <div class="register-btn"
             @click="dataFormSubmitHandle()">
          <span>{{ $t('protaRegister.registerBtn') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'

export default {
  components: {
  },
  data () {
    return {
      tabIndex: 0,
      captchaPath: '',
      dataForm: {
        username: '',
        userNameCn: '',
        email: '',
        mobile: '',
        password: '',
        passwordSure: '',
        captcha: ''
      }
    }
  },
  computed: {
    // 表单校验规则
    dataRule () {
      // 判断密码与确认密码是否相同
      let passwordSame = (rule, value, callback) => {
        if (this.dataForm.password !== this.dataForm.passwordSure) {
          return callback(new Error(this.$t('updatePassword.validate.comfirmPassword')))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userNameCn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 手机号非空和格式校验
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.validateMobile, trigger: 'blur' }
        ],
        // 密码格式 验证内容是否英文数字以及下划线
        password: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.isPassword, trigger: 'blur' }
        ],
        // 确认密码格式 加是否相同
        passwordSure: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.isPassword, trigger: 'blur' },
          { validator: passwordSame, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 邮箱格式
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    changeTab (index) {
      this.tabIndex = index
    },
    // 获取验证码
    getCaptcha () {
      //   this.dataForm.uuid = getUUID()
      //   this.captchaPath = `${window.SITE_CONFIG['apiURL']}/captcha.jpg?uuid=${this.dataForm.uuid}`
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post('/sys/register',
          this.dataForm
        ).then((res, total, code, data) => {
          // 成功后跳转登录画面
          this.$router.replace({ name: 'protalMain' })
        }).catch(() => { })
      })
    }, 5000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss">
.protal-register {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  border-top: 2px solid #1b69d4;
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    font-size: 16px;
    color: #aaa;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 16px;
    color: #aaa;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 16px;
    color: #aaa;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-size: 16px;
    color: #aaa;
  }
  .register-content {
    position: relative;
    width: 450px;
    .hide-input {
      width: 0;
      border: none;
      height: 0;
      padding: 0;
    }
    .bmw-logo {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 64px;
      height: 70px;
      box-shadow: 0 0 10px #ccc;
      background-image: url("../../assets/img/protal/bmw-logo.png");
      background-size: 100%;
    }
    .content-middle {
      width: 360px;
      margin: 0 auto;
      .big-title {
        margin-top: 60px;
        line-height: 40px;
        font-size: 24px;
        color: #1b69d4;
      }

      .register-form {
        margin-top: 40px;
        margin-bottom: 20px;
        .form-content {
          position: relative;
          border-bottom: 1px solid #ccc;
          label {
            display: inline-block;
            width: 70px;
            color: #262626;
            font-size: 16px;
          }
          input {
            width: 260px;
            height: 50px;
            margin-left: 10px;
            font-size: 20px;
            color: #262626;
            border: none;
          }
          .captcha {
            display: flex;
            width: 100px;
            height: 50px;
            position: absolute;
            top: 0;
            right: 0;
            align-items: center;
            img {
              width: 100px;
            }
          }
        }
        .register-bar {
          display: flex;
          margin-top: 20px;
          margin-bottom: 40px;
          justify-content: space-between;
          .find-password {
            color: #1b69d4;
          }
          span {
            color: #1b69d4;
          }
        }
      }
      .register-btn {
        display: flex;
        cursor: pointer;
        margin-top: 18px;
        width: 360px;
        height: 45px;
        font-size: 18px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        background: #1b69d4 100%;
      }
      .regist-btn {
        background: #262626 100%;
      }
    }
  }
}
</style>
